import { useContext } from "react";

import { DateRenderContext } from "./DateRenderContext";

export const useDateRender = () => {
    const context = useContext(DateRenderContext);

    if (!context) {
        throw new Error("DateRender context does not exist");
    }

    return context;
};
